import React from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { Button } from "@/components/ui/button";
import { X, Check } from "lucide-react";

/**
 * ImageCropTool - Crop UI component
 * Handles image cropping with ReactCrop
 */
const ImageCropTool = ({
	imageToCrop,
	crop,
	onCropChange,
	onCropComplete,
	onApplyCrop,
	imgRef,
	onCancel,
	onImageLoaded,
}) => {
	if (!imageToCrop) {
		return null;
	}

	return (
		<div className="relative flex h-full w-full items-center justify-center bg-black p-4">
			<div style={{ maxWidth: "90vw", maxHeight: "70vh" }}>
				<ReactCrop
					crop={crop}
					onChange={onCropChange}
					onComplete={onCropComplete}
					aspect={1}
					minWidth={100}
					minHeight={100}
					keepSelection
					disabled={false}
				>
					<img
						ref={imgRef}
						src={imageToCrop}
						alt="Crop"
						style={{
							maxWidth: "90vw",
							maxHeight: "70vh",
							width: "auto",
							height: "auto",
							objectFit: "contain",
							display: "block",
						}}
						onLoad={onImageLoaded}
					/>
				</ReactCrop>
			</div>

			{/* Crop controls - below the header */}
			<div className="absolute left-1/2 top-16 z-20 flex -translate-x-1/2 transform gap-2">
				<Button
					onClick={onCancel}
					variant="outline"
					size="sm"
					className="bg-black/60 text-white hover:bg-black/80"
				>
					<X size={16} className="mr-2" />
					Cancel
				</Button>
				<Button
					onClick={onApplyCrop}
					disabled={!crop}
					size="sm"
					className="bg-white text-black hover:bg-gray-200"
				>
					<Check size={16} className="mr-2" />
					Apply Crop
				</Button>
			</div>

			{/* Instructions - at the bottom */}
			<div className="absolute bottom-4 left-1/2 z-10 -translate-x-1/2 transform rounded-md bg-black/60 px-3 py-2 text-xs text-white backdrop-blur-sm">
				Drag the crop box to move it, drag corners to resize
			</div>
		</div>
	);
};

export default ImageCropTool;
